import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
    SearchFilterDefinition,
    SearchFilterSelection,
    SearchFilterValue,
} from 'shared/search-engine';
import {
    MATHIA_PARCOURS_SEARCH_FILTER_CONFIG,
    MathiaFacetScope,
    MathiaSearchFilterConfig,
} from '../mathia-search-filter-config';
import {MathiaGenericSearchFilterComponent} from '../mathia-generic-search-filter/mathia-generic-search-filter.component';

@Component({
    selector: 'app-mathia-lessons-search-filter',
    standalone: true,
    imports: [MathiaGenericSearchFilterComponent],
    templateUrl: './mathia-lessons-search-filter.component.html',
})
export class MathiaLessonsSearchFilterComponent {
    @Input() public definitions: readonly SearchFilterDefinition<SearchFilterValue>[] = [];
    @Input() public initialSelection: SearchFilterSelection<SearchFilterValue> = {};
    @Input() public resultCount: number | null = null;
    @Output() public selectionChange = new EventEmitter<SearchFilterSelection<SearchFilterValue>>();

    public readonly filterConfig: readonly MathiaSearchFilterConfig[] = MATHIA_PARCOURS_SEARCH_FILTER_CONFIG;
    public readonly facetScope: MathiaFacetScope = 'lesson';
}
